import { Component } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export default class ErrorBoundary extends Component {
  static defaultProps = {
    onComponentCatch: () => {},
    errorFallback: /*#__PURE__*/_jsx("div", {})
  };
  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true
    };
  }
  state = {
    hasError: false
  };
  componentDidCatch(error, errorInfo) {
    this.props.onComponentCatch(error, errorInfo);
  }
  reset = () => {
    this.setState({
      hasError: false
    });
  };
  render() {
    const {
      errorFallback,
      children
    } = this.props;
    const {
      hasError
    } = this.state;
    if (hasError) {
      return typeof errorFallback === 'function' ? errorFallback(hasError, this.reset) : errorFallback;
    }
    return children;
  }
}